export default __webpack_public_path__ + "static/media/fourJokersPanel.53a04d6a.jpg";